/* index.js */

"use strict";

module.exports = {
    deleteButtonFormatter
};

function deleteButtonFormatter(row, cell, value, columnDef, dataContext) {
    const button = document.createElement("base-icon-gl");
    button.dataset.icon = "common.trash_bin";
    button.setDarkTheme(true);

    button.setAttribute("aria-label", `delete ${dataContext.name}`);
    button.setAttribute("role", "button");

    button.dataset.uuid = dataContext.id;
    button.dataset.action = "delete";

    return button.outerHTML;
}